/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetYoutubeTranscriptParams,
  PaginatedYoutubeVideos,
  SearchYoutubeVideosParams,
  StandardError,
  YoutubeTranscript,
  YoutubeVideo
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Search YouTube videos
 */
export const searchYoutubeVideos = (
    params: MaybeRefOrGetter<SearchYoutubeVideosParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedYoutubeVideos>(
      {url: `/youtube/videos`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchYoutubeVideosQueryKey = (params?: MaybeRefOrGetter<SearchYoutubeVideosParams>,) => {
    return [
    'youtube','videos', ...(params ? [params] : [])
    ] as const;
    }


export const getSearchYoutubeVideosQueryOptions = <TData = Awaited<ReturnType<typeof searchYoutubeVideos>>, TError = ErrorType<StandardError>>(params: MaybeRefOrGetter<SearchYoutubeVideosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchYoutubeVideos>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchYoutubeVideosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchYoutubeVideos>>> = ({ signal }) => searchYoutubeVideos(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchYoutubeVideos>>, TError, TData>
}

export type SearchYoutubeVideosQueryResult = NonNullable<Awaited<ReturnType<typeof searchYoutubeVideos>>>
export type SearchYoutubeVideosQueryError = ErrorType<StandardError>


/**
 * @summary Search YouTube videos
 */

export function useSearchYoutubeVideos<TData = Awaited<ReturnType<typeof searchYoutubeVideos>>, TError = ErrorType<StandardError>>(
 params: MaybeRefOrGetter<SearchYoutubeVideosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchYoutubeVideos>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchYoutubeVideosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get YouTube video metadata
 */
export const getYoutubeVideo = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<YoutubeVideo>(
      {url: `/youtube/videos/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetYoutubeVideoQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'youtube','videos',id
    ] as const;
    }


export const getGetYoutubeVideoQueryOptions = <TData = Awaited<ReturnType<typeof getYoutubeVideo>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYoutubeVideo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetYoutubeVideoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getYoutubeVideo>>> = ({ signal }) => getYoutubeVideo(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getYoutubeVideo>>, TError, TData>
}

export type GetYoutubeVideoQueryResult = NonNullable<Awaited<ReturnType<typeof getYoutubeVideo>>>
export type GetYoutubeVideoQueryError = ErrorType<void>


/**
 * @summary Get YouTube video metadata
 */

export function useGetYoutubeVideo<TData = Awaited<ReturnType<typeof getYoutubeVideo>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYoutubeVideo>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetYoutubeVideoQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Get YouTube video transcript
 */
export const getYoutubeTranscript = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetYoutubeTranscriptParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<YoutubeTranscript>(
      {url: `/youtube/videos/${id}/transcripts`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetYoutubeTranscriptQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetYoutubeTranscriptParams>,) => {
    return [
    'youtube','videos',id,'transcripts', ...(params ? [params] : [])
    ] as const;
    }


export const getGetYoutubeTranscriptQueryOptions = <TData = Awaited<ReturnType<typeof getYoutubeTranscript>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetYoutubeTranscriptParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYoutubeTranscript>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetYoutubeTranscriptQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getYoutubeTranscript>>> = ({ signal }) => getYoutubeTranscript(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getYoutubeTranscript>>, TError, TData>
}

export type GetYoutubeTranscriptQueryResult = NonNullable<Awaited<ReturnType<typeof getYoutubeTranscript>>>
export type GetYoutubeTranscriptQueryError = ErrorType<void>


/**
 * @summary Get YouTube video transcript
 */

export function useGetYoutubeTranscript<TData = Awaited<ReturnType<typeof getYoutubeTranscript>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetYoutubeTranscriptParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYoutubeTranscript>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetYoutubeTranscriptQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






